// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__15aI8","range":"MonthRangeSwitch_range__KyrnE","disabled":"MonthRangeSwitch_disabled__1-SKI"};